import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { formatVal } from '../../../helpers/value'
import {
  resetStore,
  selectTotalPortfolios,
  selectTotalSeperateCompanies,
} from './store/slice'
import { getTotalSeperateCompanies } from './store/thunk'

export const HeaderContent = () => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const totalPortfolios = useSelector(selectTotalPortfolios)
  const totalCompany = useSelector(selectTotalSeperateCompanies)

  useEffect(() => {
    dispatch(getTotalSeperateCompanies())
  }, [])

  useEffect(() => {
    return () => resetStore()
  }, [])

  return (
    <div className="fw600">
      <Translate value="portfolio.summary.TOTAL_PORTFOLIOS" />: &nbsp;
      {formatVal(totalPortfolios, locale, false, 0)}
      &nbsp;
      <Translate
        value="portfolio.summary.PORTFOLIO_COUNT"
        suffix={true ? 's' : ''}
      />
      &nbsp;|&nbsp;
      {formatVal(totalCompany, locale, false, 0)}
      &nbsp;
      <Translate value="portfolio.summary.SEPARATE_COMPANY_COUNT" />
    </div>
  )
}
